import { useRef } from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import useClickOutside from "../../../../hooks/useClickOutside";

const handleClick = (e, week) => {
  e.preventDefault();
  const x = (week - 1) * 300;
  window.scrollTo({ left: x, behavior: "smooth" });
};

const WeekConfiguration = ({
  weeks,
  cycleId,
  programNumber,
  handleDiscard,
}) => {
  const footerRef = useRef(null);
  useClickOutside(footerRef, handleDiscard, true);
  return (
    <footer className="week-configuration" ref={footerRef}>
      <button
        data-button-type="tertiary"
        data-icon-only="true"
        onClick={handleDiscard}
      >
        <SvgIcon src="/img/new-icons/red-cross.svg" noFilterOnLight />
      </button>

      <div className="weeks-row">
        {Object.keys(weeks).map((weekIndex) => (
          <div className="week" key={`paneltoggle${weekIndex}`}>
            <button
              data-button-type="secondary"
              onClick={(e) => handleClick(e, weekIndex)}
            >
              Week {weekIndex}
            </button>

            <div className="controls">
              <a
                data-button-type="secondary"
                data-icon-only
                role="button"
                aria-disabled={weekIndex == 1}
                href={`/actions/cycle/coach-reorder-week/${cycleId}/${programNumber}/${weekIndex}/${
                  parseInt(weekIndex) - 1
                }`}
              >
                <SvgIcon src="/img/new-icons/arrow-square-left.svg" />
              </a>
              <a
                data-button-type="secondary"
                data-icon-only
                role="button"
                aria-disabled={weekIndex == Object.keys(weeks).length}
                href={`/actions/cycle/coach-reorder-week/${cycleId}/${programNumber}/${weekIndex}/${
                  parseInt(weekIndex) + 1
                }`}
              >
                <SvgIcon src="/img/new-icons/arrow-square-right.svg" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </footer>
  );
};

export default WeekConfiguration;
